let routes = [
  {
    path: '/*',
    component: () => import('@/views/Errors/NotFound'),
  },
];

export default routes;
